export const inputValuesTemplate = (inputs = []) => {
  let values = {}
  inputs.map(input => {
    values = {
      ...values,
      [input.input.value]: '',
    }
  })
  return `export const initialValues = ${JSON.stringify(values, null, 2)}
  `
}

export const inputsValidatesTemplate = (inputs = []) => {
  const inputsRequired = inputs.filter(input => input.input.isRequired)
  let valuesValidate = {}
inputsRequired.map(input => {
    valuesValidate = {
      ...valuesValidate,
      [input.input.value]: {
        required: true,
      },
    }
  })
  
  return `export const fieldValidations = ${JSON.stringify(valuesValidate, null, 2)}
  `
}



const templatesInputs = (props) => {
  const { type, label, cols, value, isRequired } = props
  return type === 'text'
          ? `
          <Grid item xs={12} sm={${cols}}>
            <TextField 
              label="${label}" 
              name="${value}" 
              value={${value}} 
              variant='outlined' 
              fullWidth 
              size="small" 
              required={${isRequired}} 
              error={fieldErrors.${value}}
              helperText={fieldErrors.${value} || ""}
              onChange={handleInputOnChange}
            />
          </Grid>
          `
          : `
          <Grid item xs={12} sm={${cols}}>
            <SelectComponent 
              label="${label}" 
              name="${value}"
              value={${value}} 
              options={[]} 
              small 
              required={${isRequired}} 
              error={fieldErrors.${value}}
              helperText={fieldErrors.${value} || ""}
              onChange={handleInputOnChange}
            />
          </Grid>
          `
}

export const formTemplate = (inputs = []) => {
  const inputsValues = inputs.map(input => input.input.value).join(', ')
  const components = inputs.map(inp => templatesInputs(inp.input)).join(' ')
  let template = ` import React from 'react'
  import { FormControl, FormLabel, Grid } from '@material-ui/core'
  //Importa useForm desde la carpeta /hooks
  //importar initialValues y fieldValidations
  //importar RegularButton de /customButtons
 
  export const TemplateComponente = () => {
    const { inputValues, handleInputOnChange, cleanForm, runValidates,  handleNewValues,
      fieldErrors, } = useForm(initialValues, fieldValidations)
      const { ${ inputsValues } } = inputValues

      const handleSubmit = (e) => {
        e.preventDefault()
        if(runValidates()) return // valida los campos requeridos
        // ...logica
      }
    return (
      <FormControl>
        <FormLabel>
          { /* Nombre Formulario  */ }
        </FormLabel>
        <Grid container spacing={1}
        >
          ${components}
          <Grid item xs={12}>
            <RegularButton
              size="sm"
              color="info"
              tooltip="Aceptar"
              onClick={handleSubmit}
            >
              Ejemplo
            </RegularButton>
          </Grid>
        </Grid>
      </FormControl>
    )
  }
  `

  return template
}
